import { BlockProps } from '../type';
import { IBillContent, IBillContentBlock } from './type';

interface Props {
  key: string;
  label: string;
  data: IBillContent;
}

export const createBillContentBlock = (props: Props): IBillContentBlock => {
  const block: IBillContentBlock = {
    type: 'bill',
    isVisible: false,
    x: 0,
    y: 0,
    location: 'content',
    currencyType: '',
    ...props,
  };

  return block;
};

export function isBillContentBlock(
  block: BlockProps,
): block is IBillContentBlock {
  return block.type === 'bill';
}
